import * as Configuration from 'src/ajs-app/app.constants.js';
import { CapabilityIdEnum } from 'src/app/shared/capabilities-and-permissions';

export class PublicationService {
  constructor($http, AsyncRequestFactory, UserFactory, DropdownItemsFactory) {
    this.$http = $http;
    this.AsyncRequestFactory = AsyncRequestFactory;
    this.UserFactory = UserFactory;
    this.DropdownItemsFactory = DropdownItemsFactory;
  }

  getPublications(companyId, status, filters, dateRange, pageSize, pageNumber) {
    let url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/publications2';

    let params = {
      status: status,
      from_date: dateRange.from,
      to_date: dateRange.to,
      search_input: filters.searchInput,
      page_size: pageSize,
      page_number: pageNumber,
    };

    const siteIds = filters.accounts;
    if (siteIds && siteIds.length > 0) {
      params['site_ids'] = JSON.stringify(siteIds);
    }

    return this.$http.get(url, { params });
  }

  getPublicationsTwitterStats(companyId, publicationIds) {
    let url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/publications2/twitter-stats';

    let params = {
      publication_ids: JSON.stringify(publicationIds),
    };

    return this.AsyncRequestFactory.get(companyId, url, params);
  }

  /**
   * migrated
   */
  createPublication(companyId, siteId, parentPublicationId) {
    let url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/publications2';

    let data = {
      site_id: siteId,
      parent_publication_id: parentPublicationId
    };

    return this.$http.post(url, data);
  }

  /**
   * migrated
   */
  updatePublication(companyId, siteId, publicationId, editorContent, picturesAlt, internalNote,
    publicationTime, attachedLink) {
    let url =
      Configuration.constants.baseUrl +
      'api/1.0/companies/' +
      companyId +
      '/sites/' +
      siteId +
      '/publications2/' +
      publicationId;

    let data = {
      editor_content: editorContent,
      pictures_alt: picturesAlt,
      internal_note: internalNote,
      publication_time: publicationTime,
      attached_link: attachedLink
    };

    return this.$http.put(url, data);
  }

  /**
   * migrated
   */
  publishNow(companyId, siteId, publicationId) {
    let url =
      Configuration.constants.baseUrl +
      'api/1.0/companies/' +
      companyId +
      '/sites/' +
      siteId +
      '/publications2/' +
      publicationId +
      '/publish-now';
    return this.AsyncRequestFactory.post(companyId, url);
  }

  /**
   * migrated
   */
  schedule(companyId, siteId, publicationId) {
    let url =
      Configuration.constants.baseUrl +
      'api/1.0/companies/' +
      companyId +
      '/sites/' +
      siteId +
      '/publications2/' +
      publicationId +
      '/schedule';

    return this.AsyncRequestFactory.post(companyId, url);
  }

  /**
   * migrated
   */
  markAsDraft(companyId, siteId, publicationId) {
    let url =
      Configuration.constants.baseUrl +
      'api/1.0/companies/' +
      companyId +
      '/sites/' +
      siteId +
      '/publications2/' +
      publicationId +
      '/mark-as-draft';

    return this.$http.post(url);
  }

  retweet(companyId, siteId, publicationId, retweetWithSiteId) {
    let url =
      Configuration.constants.baseUrl +
      'api/1.0/companies/' +
      companyId +
      '/sites/' +
      siteId +
      '/publications2/' +
      publicationId +
      '/retweet';

    let data = {
      retweet_with_site_id: retweetWithSiteId,
    };

    return this.AsyncRequestFactory.post(companyId, url, data);
  }

  like(companyId, siteId, publicationId, likeWithSiteId) {
    let url =
      Configuration.constants.baseUrl +
      'api/1.0/companies/' +
      companyId +
      '/sites/' +
      siteId +
      '/publications2/' +
      publicationId +
      '/like';

    let data = {
      like_with_site_id: likeWithSiteId,
    };

    return this.AsyncRequestFactory.post(companyId, url, data);
  }

  deletePublication(companyId, siteId, publicationId) {
    let url =
      Configuration.constants.baseUrl +
      'api/1.0/companies/' +
      companyId +
      '/sites/' +
      siteId +
      '/publications2/' +
      publicationId;

    return this.AsyncRequestFactory.delete(companyId, url);
  }

  getPublication(companyId, siteId, publicationId, filters) {
    let url =
      Configuration.constants.baseUrl +
      'api/1.0/companies/' +
      companyId +
      '/sites/' +
      siteId +
      '/publications2/' +
      publicationId;

    let params = {
      from_date: filters.dateRange.from,
      to_date: filters.dateRange.to,
      search_input: filters.searchInput
    };
    return this.$http.get(url, { params });
  }

  retrieveExternalPublications(companyId) {
    let url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/external-publications';

    return this.AsyncRequestFactory.post(companyId, url);
  }

  buildDropdownItems(sites) {
    const filteredSites = sites.filter(({ id }) => this.UserFactory.hasCapability(id, CapabilityIdEnum.Publish));
    return {
      sites: this.DropdownItemsFactory.buildSiteItems(filteredSites),
    };
  }

  static PublicationFactory($http, AsyncRequestFactory, UserFactory, DropdownItemsFactory) {
    return new PublicationService($http, AsyncRequestFactory, UserFactory, DropdownItemsFactory);
  }
}

PublicationService.PublicationFactory.$inject = ['$http', 'AsyncRequestFactory', 'UserFactory', 'DropdownItemsFactory'];
